import { combineReducers } from "redux";
import userReducer from "../reducers/userReducer"; // 假設你有一個名為 userReducer.js 的 reducer

const rootReducer = combineReducers({
  user: userReducer, // 添加其他 reducer
});

export default rootReducer;
